export class PartialAuthData {
    success: boolean = false;
    maxPlans: number = 0;
    choosedToKeepCount: number = 0;
    priceOptionCodes: Array<string> = [];
    productVersion: string = '';
}

export class LicenseData extends PartialAuthData { 
    licenseStatus: string | undefined;
    licenseStartDate: string | undefined;
    licenseEndDate: string | undefined;
    licenseID: number = 0;
    licenseCompanies: string = '';
    subscriptionID: string = '';
    subscriptionCurrencyCode: string = '';
}

export class AuthData extends LicenseData {    
    isAuthenticated: boolean = false;
    data: string = '';
    fullname: string = '';
    email: string = '';
    level: number = 0;
    planObjectLimit: number = 0;
    maxPlanDuration: number = 0;
    lastPlanGUID: string = '';
    lastCurrencyId: number = 0;
    currencyPosition: number = 0;
    choosedToKeepSelected: boolean = false;
    isNotifyJSError: boolean = false;
    isPlanTourActive: boolean = false;
    licenseOwnerEmail: string | undefined;
    isLicenseOwner: number = 0;
    expiredNoticeCount: number = 0;
    lastSortTypes: string = '';
    isRememberMe: boolean = false;
    isSessionTimeout: boolean = false;
    isTemporaryLicense: boolean = false;    
    isPaidOnSignup: boolean = false;
    userID: number = 0;
    isViewHistoryMode: boolean = false;
    viewHistoryID: number = 0;
    isSharedPlan: boolean = false;
    betaFeatures: Array<string> = [];
    companyGuid: string = '';
    teamOwnerId: number = -1;
    planDurationYears: Array<{ id: number, value: string, disabled: boolean }> = [];
    licenseLapsed: boolean = false;
    licenseUnitAmount: number = 0;
    licensesCount: number = 0;
    spareLicensesCount: number = 0;
    lastTaxSystem: string = '';
    lastCompanyId: number = 0;
    HasEverHadTrial: boolean = false;
    buildVersion: string = '';
    xeroAuthOptions: XeroAuthOptionsDto = new XeroAuthOptionsDto();
    accessToken: string = '';
    sessionId: string = '';
    isRedirectedFromCrunch = false;
}

class XeroAuthOptionsDto {
    isXeroAuthorized: boolean = false;
    xeroConnectMode: string = '';
    isRedirectedFromXero: boolean = false;
    isXeroAuthorizeFailed: boolean = false;
}
